var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 0H3.1C1.395 0 0.0155 1.2375 0.0155 2.75L0 19.25C0 20.7625 1.395 22 3.1 22H27.9C29.605 22 31 20.7625 31 19.25V2.75C31 1.2375 29.605 0 27.9 0ZM27.28 5.84375L16.3215 11.9213C15.8255 12.1962 15.1745 12.1962 14.6785 11.9213L3.72 5.84375C3.56458 5.76635 3.42847 5.66178 3.31993 5.53637C3.21138 5.41096 3.13265 5.26732 3.08849 5.11414C3.04434 4.96095 3.03568 4.80141 3.06304 4.64517C3.09041 4.48893 3.15322 4.33924 3.24769 4.20516C3.34215 4.07108 3.4663 3.9554 3.61263 3.86512C3.75895 3.77483 3.9244 3.71183 4.09897 3.67991C4.27354 3.64799 4.45359 3.64783 4.62823 3.67943C4.80287 3.71103 4.96847 3.77373 5.115 3.86375L15.5 9.625L25.885 3.86375C26.0315 3.77373 26.1971 3.71103 26.3718 3.67943C26.5464 3.64783 26.7265 3.64799 26.901 3.67991C27.0756 3.71183 27.241 3.77483 27.3874 3.86512C27.5337 3.9554 27.6578 4.07108 27.7523 4.20516C27.8468 4.33924 27.9096 4.48893 27.937 4.64517C27.9643 4.80141 27.9557 4.96095 27.9115 5.11414C27.8674 5.26732 27.7886 5.41096 27.6801 5.53637C27.5715 5.66178 27.4354 5.76635 27.28 5.84375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4eb67f4da24cc7efa6b1278e385e60e2.svg";
export { ForwardRef as ReactComponent };